// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__39y_0","content":"ManualTimeModal_content__2Fx-6"};